import $ from "jquery";

class Scroll {
  constructor() {
    this.ct = 0;
    this.maxt = 0;
    this.scrt = 0;
    this.dt = null;
    this.oYp = null;
    this.oYc = null;
    this.elem = null;
    this.elClass = "";
    this.im = false;
  }

  // 创建滚动条
  create() {
    this.elem = document.querySelector(this.elClass);
    const pTargetName =
      this.elem.nodeName === "UL" || this.elem.nodeName === "OL" ? "li" : "div";
    const scr = this.elem.querySelector(".m-scroll-parent-y");
    if (!scr) {
      this.oYp = document.createElement(pTargetName);
      this.oYc = document.createElement("div");
      this.oYp.className = "m-scroll-parent-y";
      this.oYc.className = "m-scroll-child-y";
      this.oYp.appendChild(this.oYc);

      this.elem.appendChild(this.oYp);
    }

    const pos = getComputedStyle(this.elem, false).position;
    if (["relative", "absolute", "fixed"].indexOf(pos) === -1) {
      this.elem.style.position = "relative";
    }
    this.elem.style.overflow = "hidden";
  }

  initWH() {
    const ecwy = this.elem.clientHeight;
    const eswy = this.elem.scrollHeight;

    if (ecwy >= eswy) {
      this.oYp.style.display = "none";
    } else {
      this.oYp.style.display = "block";
    }
    // const pcwy = this.oYp.offsetHeight;
    // let scay = Math.abs(ecwy / eswy * pcwy);
    // this.maxt = pcwy - scay;

    const pcwy = this.oYp.offsetHeight;
    let scay = Math.abs((ecwy / eswy) * pcwy);
    this.scrt = eswy - ecwy;

    if (scay < 50) {
      scay = 50;
    }
    this.maxt = pcwy - scay;
    this.oYc.style.height = scay + "px";

    this.resetClt();
  }

  addEvent() {
    const self = this;
    $(this.elem).on("mousewheel DOMMouseScroll", e => {
      const ev = e.originalEvent;
      const y = ev.wheelDeltaY;
      const fx = ev.wheelDelta || ev.detail;
      this.isDir(ev, fx);
      this.setXY(ev);
      this.st = y;
    });

    $(this.oYc)
      .off("mousedown")
      .on("mousedown", function(ev) {
        const disY = ev.clientY - this.offsetTop;
        $(document).on("mousemove.dragy", ev1 => {
          self.im = true;
          self.ct = ev1.clientY - disY;
          self.setXY(ev1);
          return false;
        });
        $(document).on("mouseup.dragy", () => {
          self.im = false;
          $(document).off(".dragy");
        });
        return false;
      });
  }

  isDir(ev, fx) {
    let bDown = true;
    if (ev.detail) {
      bDown = fx > 0;
    } else {
      bDown = fx < 0;
    }
    if (bDown) {
      this.ct += 10;
    } else {
      this.ct -= 10;
    }
  }

  setXY(ev) {
    let isDis = true;
    if (this.ct < 0) {
      isDis = false;
      this.ct = 0;
    } else if (this.ct > this.maxt) {
      isDis = false;
      this.ct = this.maxt;
    }
    let t = Math.round((this.ct * this.scrt) / this.maxt);
    if (t < 0) {
      t = 0;
    }

    this.oYc.style.top = this.ct + "px";
    this.oYp.style.top = t + "px";

    this.elem.scrollTop = t;

    if (isDis) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  resetClt() {
    if (this.ct > this.maxt) {
      this.setXY();
      return;
    }
    if (this.ct === 0) {
      this.oYp.style.top = 0;
    }
  }

  // 重置滚动条
  reset() {
    this.oYp.style.top = 0;
    this.oYc.style.top = 0;
    this.elem.scrollTop = 0;
    this.ct = 0;
    this.initWH();
  }

  interval() {
    this.initWH();
    clearTimeout(this.dt);
    this.dt = setTimeout(() => {
      this.interval();
    }, 1000);
  }

  init(elClass, evName) {
    this.elClass = elClass;
    $(document)
      .off("." + evName)
      .on("mouseenter." + evName, this.elClass, () => {
        this.create();
        // this.reset();
        this.addEvent();
        this.interval();
      })
      .on("mouseleave." + evName, this.elClass, () => {
        if (!this.im) {
          this.oYp.style.display = "none";
        }
        clearInterval(this.dt);
      });
  }
}

export function createScroll(elClass, evName) {
  const scr = new Scroll();
  scr.init(elClass, evName);
}

export { Scroll };
